import { FormEvent } from "react";
import { Dispatch } from "redux";
import { EmployeeInterface } from "../../../common/interfaces/EmployeeInterface";
import { handleEmailChange } from "./handleEmailChange";
import { handleEditEmployee } from "./handleEditEmployee";
import {
    EditEmployeeModalInterface,
    setResetEmailState,
} from "../EditEmployeeModalSlice";
import { getResetEmailState } from "./getResetEmailState";

interface HandleFormSubmitProps {
    event: FormEvent;
    emailError: string | null;
    newEmail: string;
    selectedEmployee?: EmployeeInterface;
    dispatch: Dispatch;
    changeEmail: (params: { id: number; newEmail: string }) => {
        unwrap: () => Promise<unknown>;
    };
    formValues: EditEmployeeModalInterface["formValues"];
    patchEditEmployee: (params: {
        id: number;
        data: Record<string, unknown>;
    }) => { unwrap: () => Promise<unknown> };
    refetchEmployeeMe?: () => Promise<unknown>;
}

export const handleFormSubmit = async (
    props: HandleFormSubmitProps,
): Promise<boolean> => {
    const {
        event,
        emailError,
        newEmail,
        selectedEmployee,
        dispatch,
        changeEmail,
        formValues,
        patchEditEmployee,
    } = props;

    event.preventDefault();

    if (emailError) {
        return false;
    }

    if (!formValues) {
        return false;
    }

    await handleEmailChange({
        newEmail,
        selectedEmployee,
        dispatch,
        changeEmail,
    });

    await handleEditEmployee({
        dispatch,
        formValues: newEmail
            ? {
                  ...formValues,
                  privateEmail: newEmail,
                  newEmail: newEmail,
              }
            : formValues,
        patchEditEmployee,
        selectedEmployee,
    });

    dispatch(setResetEmailState(getResetEmailState()));

    return true;
};
